/**
 * It takes object and returns values as array
 * usage: getValuesOfObjectAsArray({obj1: 'test1', obj2: 'test2'});
 * returns ['test1', 'test2']
 * @param {any} obj
 */
const getValuesOfObjectAsArray = function (obj) {
    const values = [];
    for (const i in obj) {
        if (obj.hasOwnProperty(i)) {
            values.push(obj[i]);
        }
    }
    return values;
};
export default getValuesOfObjectAsArray;
